import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IncidentOverviewComponent} from '../incident-overview/incident-overview.component';
import {AssetSyncComponent} from '../asset-sync/asset-sync.component';
import {TranslatePipe} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

interface Tab {
  label: string;
  contentId: string;
  component: 'incident' | 'asset';
}

@Component({
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss'],
  standalone: true,
  imports: [
    IncidentOverviewComponent,
    AssetSyncComponent,
    CommonModule,
    TranslatePipe
  ]
})
export class TabNavigationComponent implements OnInit, OnChanges {
  @Input() reloadFlag: boolean = false;
  selectedTabIndex: number;

  tabs: Tab[] = [
    {
      label: 'NAVIGATION.incidentHistory',
      contentId: 'content-1',
      component: 'incident'
    },
    {
      label: 'NAVIGATION.assetSync',
      contentId: 'content-2',
      component: 'asset'
    }
  ];

  constructor(private readonly cdRef: ChangeDetectorRef) {
  }

  /* istanbul ignore next */
  ngOnChanges(change: SimpleChanges): void {
    this.ngOnInit();
  }
  ngOnInit(): void {
    this.selectedTabIndex = 0;
  }

  selectTab(index: number) {
    this.selectedTabIndex = index;
    this.cdRef.detectChanges();
  }
}
